import { Authorization } from '../providers/AuthContextProvider';
import { useContext, useLayoutEffect } from 'react';
import Page404 from '../pages/404'
import { useLocation, useNavigate } from 'react-router-dom';

const withAuth = (WrappedComponent) => {

    const AuthComponent = (props) => {
        const push = useNavigate();
         const location = useLocation();
        const { tokens, user } = useContext(Authorization)

        const role = location.pathname.split('/')[1]

        useLayoutEffect(() => {
            if (!tokens) push("/auth/login");
        }, []);

        if (user.is_admin)
            return (role === 'admin') ? <WrappedComponent {...props} /> : <Page404 />
        else
            if (role === 'profile')
                return <WrappedComponent {...props} />
            else if (location.pathname.split('/')[2] === 'shipping')
                return <WrappedComponent {...props} />
            else
                return < Page404 />
    };

    return AuthComponent;
};

export default withAuth;
